// extracted by mini-css-extract-plugin
export var childrenContainer = "_32-0";